module.exports = __webpack_public_path__ + "static/img/10.0b479be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/10.png
// module id = 6oLr
// module chunks = 0